// extracted by mini-css-extract-plugin
export default {"tags":"TagFilter-module--tags--Stg9E","tag":"TagFilter-module--tag--29Rez","tagHolder":"TagFilter-module--tagHolder--20CGk","tagActive":"TagFilter-module--tagActive--2oF9a"};